import React, { useState, useEffect } from 'react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top scroll behavior
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div id="back-to-top" style={{ 
      position: 'fixed', 
      bottom: '20px', 
      right: '20px', 
      zIndex: 1000,
      display: isVisible ? 'block' : 'none' 
    }}>
      <a 
        href="#" 
        onClick={scrollToTop}
        className="bg-green position-relative align-items-center rounded-circle d-flex justify-content-center border border-4 border-grey"
        style={{ width: '50px', height: '50px', textDecoration: 'none' }}
        aria-label="Back to Top"
      >
        <i className="fa fa-chevron-up text-white"></i>
      </a>
    </div>
  );
};

export default BackToTop;